import { useSetPageMeta } from '@/shared/lib/context/page-meta-context'

interface DemoPageProps {
  title: string
}

export function DemoPage({ title }: DemoPageProps) {
  useSetPageMeta({ title, demo: true })
  return null
}
